<template>
  <div>
    <div class="row">
      <div class="col-lg-9 col-md-12">
        <card class="shadow-lg">      
          <div class="row content-add-btn padbtn">
            <button class="btn btn-secondary" @click="$router.go(-1);">
              <i class="fa fa-chevron-left"></i>
              Regresar
            </button>
          </div>
          <hr />        
          <form v-if="canCreate() || canUpdate()" @submit.prevent="validateForm">
            <div class="row">
              <div class="col-md-6">
                <fg-input 
                type="text" 
                label="Nombres *" 
                v-model="userForm.first_name"
                v-validate="modelValidations.first_name"
                name="nombres"
                :error="getError('nombres')">
                </fg-input>
              </div>
              <div class="col-md-6">
                <fg-input 
                type="text" 
                label="Apellidos *" 
                v-model="userForm.last_name"
                v-validate="modelValidations.last_name"
                name="apellidos"
                :error="getError('apellidos')">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <fg-input 
                type="text" 
                label="Nombre de usuario *" 
                v-model="userForm.username"
                v-validate="modelValidations.username"
                name="nombre de usuario"
                :error="getError('nombre de usuario')"
                :disabled="disabledFieldUsername">
                </fg-input>
              </div>
              <div class="col-md-6">
                <fg-input 
                type="email" 
                label="Correo Electronico *" 
                v-validate="modelValidations.email"
                name="correo electronico"
                :error="getError('correo electronico')"
                v-model="userForm.email"
                :disabled="disabledFieldEmail">
                </fg-input>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label>Rol *</label><br>
                <el-select 
                :class="selectClass" 
                class="select_modules" 
                size="large" 
                filterable placeholder="Perfil" 
                v-model="userForm.role_id">
                  <el-option v-for="option in roles" 
                  class="select-primary" 
                  :value="option.id" 
                  :label="option.name" 
                  :key="option.name">
                  </el-option>
                </el-select>
              </div>
              <div class="col-lg-6">
              <label>Departamento</label>
                <el-select filterable
                class="select-primary select_modules" 
                size="large" 
                placeholder="Departamento" 
                v-model="userForm.department_id">
                  <el-option v-for="option in departments" 
                  class="select-primary" 
                  :value="option.id" 
                  :label="option.department" 
                  :key="option.department">
                  </el-option>
                </el-select>            
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12">
              <label>Permisos</label>
                <el-select  multiple class="select-primary select_modules"
                v-model="userForm.permissions"
                filterable placeholder="Seleccione uno o varios Permisos">
                  <el-option v-for="option in permissions"
                              class="select-primary"
                              :value="option.id"
                              :label="option.name"
                              :key="option.name">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="row" v-if="errorAlert ">
              <div class="col-lg-12">
                <el-alert
                  :title="errorAlert"
                  type="error">
                </el-alert>
              </div>           
            </div><br><hr><br>  
            <div class="text-center">
              <button type="submit" class="btn btn-fill btn-danger btn-wd">
                Guardar
              </button>
            </div>
          </form>
          <div v-else>
            <div class="text-center">
              <h4> <strong> No tienes permiso para crear o editar </strong></h4>
            </div>
          </div>        
        </card>
      </div>
    </div>
  </div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import showSwalAlert from 'src/util/alerts'
  import store from '@/store'

  export default {
    data () {
      return {
        userForm: {
          first_name: null, 
          last_name: null,
          username: null,
          email: null,
          process_supervisor: null,
          temporary_password: null,
          role_id: null,
          department_id: null,
          permissions: null,
        },
        roles: null,
        departments: null,
        permissions: null,
        modelValidations: {
          first_name: {
            required: true,
          },
          last_name: {
            required: true,
          },
          username: {
            required: true,
          },
          email: {
            required: true,
          },
          rol: {
            required: true,
          }
        },
        disabledFieldEmail: false,
        disabledFieldUsername: false,  
      }
    },
    mixins: [mixinMasters, mixinPermissions],
    methods:{
      validateForm(name){
        this.$validator.validateAll().then(isValid => {
          if(isValid) {
            if( this.userForm.role_id) this.storeUpdateUser()
            else {
              this.selectClass = 'select-danger'
              this.errorAlert = 'Debe seleccionar un perfil'
              setTimeout(()=>{
                this.selectClass = 'select-primary'
                this.errorAlert = null
              }, 5000)
            }               
          }
        })
      },
      storeUpdateUser(){
        this.userForm.route = 'users'
        if (localStorage.getItem('userEdit')) {
          this.updateMaster(this.userForm).then((response) => {
            showSwalAlert(response.data.message, 'success').then(() => this.$router.push('/users'))            
          })        
        } else {
          this.saveMaster(this.userForm).then((response)=>{
            showSwalAlert(response.data.message, 'success').then(() => this.$router.push('/users'))                     
          }).catch((error) => {
            if(error.response.data.errors.username) showSwalAlert(error.response.data.errors.username[0], 'error')
            if(error.response.data.errors.email) showSwalAlert(error.response.data.errors.email[0], 'error')
          })            
        }
      },
    },
    created(){
      if(this.canCreate() || this.canUpdate()){
        if (localStorage.getItem('userEdit')) {
          this.userForm = JSON.parse(localStorage.getItem('userEdit'))
          this.disabledFieldUsername = true
          if(this.userForm.email) this.disabledFieldEmail = true
          this.title = 'Editar Usuario '+ this.userForm.first_name + ' ' +this.userForm.last_name
        }
        else this.title = 'Agregar un Usuario'
        this.getMasters('departments/index').then((response) => this.departments = response.data.data)
        this.getMasters('roles/index').then((response) => this.roles = response.data.data)
        this.getMasters('permissions/index').then((response) => this.permissions = response.data.data) 
      }
    },
    beforeDestroy(){
      localStorage.removeItem('userEdit');
    }         
  }
</script>